import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { Alert, AlertTitle, Button, Typography } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import { Theme } from '@mui/material/styles';
import { useHistory } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { contactRoutes } from '../../routes';
import { ToastContactAlert } from '../../types/ToastItem';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        '& .MuiAlert-root': {
            maxWidth: 'calc(100% - 64px)',
        },
        [theme.breakpoints.up('sm')]: {
            '& .MuiAlert-root': {
                width: '500px',
            },
        },
    },
}));

interface Props {
    config: ToastContactAlert;
    onDismissHandler: () => void;
}

export default function ContactAlertToast({ config, onDismissHandler }: Props) {
    const history = useHistory();
    const { classes } = useStyles();

    const handleNavigate = () => {
        history.push(contactRoutes.setDetails(config.contactId));

        onDismissHandler();
    };

    const handleClose = (event: object, reason?: string) => {
        if (reason !== 'clickaway') {
            onDismissHandler();
        }
    };

    return (
        <Snackbar
            open={true}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            onClose={handleClose}
            autoHideDuration={config.autoHide}
            className={classes.root}
        >
            <Alert
                icon={<SupervisorAccountIcon />}
                onClose={handleClose}
                severity="info"
                variant="filled"
                sx={{ width: '100%' }}
            >
                <AlertTitle>{config.title}</AlertTitle>
                {config.text && <Typography>{config.text}</Typography>}
                <Button
                    sx={{ mt: 1 }}
                    variant="contained"
                    color="secondary"
                    onClick={handleNavigate}
                >
                    View
                </Button>
            </Alert>
        </Snackbar>
    );
}
